// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
  text-align: center;
  color: #171717;
  background-color: #ffffff;
  border-top: 1px solid #73737333;
  min-height: 40px;
  padding: 10px 20px;
  width: 100%;
  display: flex;
  align-items: center;
  width: 100%;

  @media (min-width: 768px) {
    padding: 10px 40px;
  }
}

.Footer_footerInner__Lmt4V {
  width: 100%;
  flex-direction: column-reverse;
  gap: 20px;

  @media (min-width: 576px) {
    flex-direction: row;
    gap: 0;
  }
}

.Footer_rowLeft__iiS9k {
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 14px;
  
  @media (min-width: 576px) {
    text-align: left;
    justify-content: flex-start;
    width: 50%;
  }
}

.Footer_rowRight__BbuxN {
  justify-content: center;
  align-items: center;
  text-align: center;
  
  @media (min-width: 576px) {
    width: 50%;
    justify-content: flex-end;
    text-align: right;
  }
}

.Footer_col__uMvMM {
  cursor: pointer;
  margin-bottom: 5px;
}

.Footer_help__TPCht {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.Footer_copy__V37yO {
  color: rgba(0, 0, 0, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;;EAEX;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,SAAS;;EAET;IACE,mBAAmB;IACnB,MAAM;EACR;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,UAAU;IACV,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".footer {\n  text-align: center;\n  color: #171717;\n  background-color: #ffffff;\n  border-top: 1px solid #73737333;\n  min-height: 40px;\n  padding: 10px 20px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  @media (min-width: 768px) {\n    padding: 10px 40px;\n  }\n}\n\n.footerInner {\n  width: 100%;\n  flex-direction: column-reverse;\n  gap: 20px;\n\n  @media (min-width: 576px) {\n    flex-direction: row;\n    gap: 0;\n  }\n}\n\n.rowLeft {\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  gap: 14px;\n  \n  @media (min-width: 576px) {\n    text-align: left;\n    justify-content: flex-start;\n    width: 50%;\n  }\n}\n\n.rowRight {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  \n  @media (min-width: 576px) {\n    width: 50%;\n    justify-content: flex-end;\n    text-align: right;\n  }\n}\n\n.col {\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.help {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 20px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.copy {\n  color: rgba(0, 0, 0, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"footerInner": `Footer_footerInner__Lmt4V`,
	"rowLeft": `Footer_rowLeft__iiS9k`,
	"rowRight": `Footer_rowRight__BbuxN`,
	"col": `Footer_col__uMvMM`,
	"help": `Footer_help__TPCht`,
	"copy": `Footer_copy__V37yO`
};
export default ___CSS_LOADER_EXPORT___;
